import classNames from 'classnames';
import Tooltip from 'rc-tooltip';
import React from 'react';
import { MdInfoOutline } from 'react-icons/md';
import { type SearchedProfile } from '../interfaces';

type FromPlatformBadgeProps = {
  platform: SearchedProfile['fromPlatform'];
} & React.HTMLAttributes<HTMLDivElement>;

const FromPlatformBadge: React.FC<FromPlatformBadgeProps> = ({ className, platform }) => {
  if (!platform || platform === 'other') {
    return null;
  }
  let name = '';
  let tooltip = '';
  let colorClassName = 'badge-todo';
  switch (platform) {
    case 'exclu':
      name = 'Exclu';
      colorClassName = 'badge-exclu';
      tooltip = 'Le recruteur a signé une clause d’exclusivité avec son client';
      break;
    case 'hunteed':
      name = 'Hunteed';
      colorClassName = 'badge-hunteed';
      tooltip = 'Cette mission a été publiée sur Hunteed';
      break;
    case 'muzzo':
      name = 'Muzzo';
      colorClassName = 'badge-muzzo';
      tooltip = 'Cette mission a été publiée sur Muzzo';
      break;
  }

  return (
    <Tooltip placement="bottom" trigger={['click', 'hover']} overlayClassName="opacity-100" overlay={tooltip}>
      <span className={classNames(' flex items-center gap-1 badge', colorClassName, className)}>
        <MdInfoOutline />
        {name}
      </span>
    </Tooltip>
  );
};

export default FromPlatformBadge;
